export const BestSellerData = [
	{
		id: "1",
		SKU: "PT001",
		Product_Name: "Lenovo IdeaPad 3",
		img: "assets/img/products/stock-img-01.png",
		Brand: "Lenovo",
		Category: "Computers",
		Sold_Qty: "05",
		Sold_Amount: "$3000",
		Instock_Qty: "100",
	},
	{
		id: "2",
		SKU: "PT002",
		Product_Name: "Beats Pro",
		img: "assets/img/products/stock-img-06.png",
		Brand: "Beats",
		Category: "Electronics",
		Sold_Qty: "10",
		Sold_Amount: "$1600",
		Instock_Qty: "140",
	},
	{
		id: "3",
		SKU: "PT003",
		Product_Name: "Nike Jordan",
		img: "assets/img/products/stock-img-02.png",
		Brand: "Nike",
		Category: "Shoe",
		Sold_Qty: "08",
		Sold_Amount: "$880",
		Instock_Qty: "300",
	},
	{
		id: "4",
		SKU: "PT004",
		Product_Name: "Apple Series 5 Watch",
		img: "assets/img/products/stock-img-03.png",
		Brand: "Apple",
		Category: "Electronics",
		Sold_Qty: "10",
		Sold_Amount: "$1200",
		Instock_Qty: "450",
	},
	{
		id: "5",
		SKU: "PT005",
		Product_Name: "Amazon Echo Dot",
		img: "assets/img/products/stock-img-04.png",
		Brand: "Amazon",
		Category: "Electronics",
		Sold_Qty: "05",
		Sold_Amount: "$400",
		Instock_Qty: "320",
	},
	{
		id: "6",
		SKU: "PT006",
		Product_Name: "Sanford Chair Sofa",
		img: "assets/img/products/stock-img-05.png",
		Brand: "Modern Wave",
		Category: "Furniture",
		Sold_Qty: "07",
		Sold_Amount: "$2240",
		Instock_Qty: "650",
	},
	{
		id: "7",
		SKU: "PT007",
		Product_Name: "Red Premium Satchel",
		img: "assets/img/products/expire-product-01.png",
		Brand: "Dior",
		Category: "Bags",
		Sold_Qty: "15",
		Sold_Amount: "$900",
		Instock_Qty: "700",
	},
	{
		id: "8",
		SKU: "PT008",
		Product_Name: "Iphone 14 Prol",
		img: "assets/img/products/expire-product-02.png",
		Brand: "Apple",
		Category: "Phone",
		Sold_Qty: "12",
		Sold_Amount: "$6480",
		Instock_Qty: "630",
	},
	{
		id: "9",
		SKU: "PT009",
		Product_Name: "Gaming Chair",
		img: "assets/img/products/expire-product-03.png",
		Brand: "Arlime",
		Category: "Furniture",
		Sold_Qty: "10",
		Sold_Amount: "$2000",
		Instock_Qty: "410",
	},
	{
		id: "10",
		SKU: "PT010",
		Product_Name: "Borealis Backpack",
		img: "assets/img/products/expire-product-04.png",
		Brand: "The North Face",
		Category: "Bags",
		Sold_Qty: "20",
		Sold_Amount: "$900",
		Instock_Qty: "550",
	},
];
